(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart"]) return;
  try {
    
  (() => {
    const root = document.querySelector('[data-ode-cart-page]');
    if (!root) return;

    const storageKey = 'cupids-ode-saved-pieces';
    const tabs = [...root.querySelectorAll('[data-ode-cart-tab]')];
    const panels = [...root.querySelectorAll('[data-ode-cart-panel]')];
    const savedGrid = root.querySelector('[data-ode-saved-grid]');
    const savedCount = root.querySelector('[data-ode-saved-count]');
    const savedStatus = root.querySelector('[data-ode-saved-status]');
    const cartTabCount = root.querySelector('[data-ode-cart-tab-count]');
    const cartSummaryCount = root.querySelector('[data-ode-cart-summary-count]');
    const cartSubtotal = root.querySelector('[data-ode-cart-subtotal]');
    const cartDiscounts = root.querySelector('[data-ode-cart-discounts]');
    const discountInput = root.querySelector('[data-ode-discount-input]');
    const discountButton = root.querySelector('[data-ode-discount-apply]');
    const discountStatus = root.querySelector('[data-ode-discount-status]');
    const editDialogs = [...root.querySelectorAll('[data-ode-cart-edit-dialog]')];
    const productCache = new Map();
    const routesRoot = window.Shopify?.routes?.root || '/';
    // Black Friday offers: window.odeOffers comes from the bag
    // (sections/ode-shopping-refinement.liquid), which loads on every page.
    const firstCart = (() => {
      try { return JSON.parse(root.querySelector('[data-ode-cart-json]')?.textContent || 'null'); } catch { return null; }
    })();
    const paintOffers = (cart) => window.odeOffers?.paint(root, cart);
    const updateCodes = async (discount) => {
      const response = await fetch(`${routesRoot}cart/update.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ discount }),
      });
      if (!response.ok) throw new Error('Discount update failed');
      return response.json();
    };

    // Prices written here after an update match the ones Liquid wrote: odeMoney
    // (layout/theme.liquid) copies Liquid's format, so a yen bag does not gain
    // decimals and a euro one keeps its decimal comma. Intl is the fallback.
    const money = (cents, currency, withCurrency = false) => {
      const formatted = window.odeMoney?.format(cents, { coded: withCurrency });
      if (formatted) return formatted;
      const amount = new Intl.NumberFormat(document.documentElement.lang || 'en-US', {
        style: 'currency',
        currency,
      }).format(cents / 100);
      return withCurrency ? `${amount} ${currency}` : amount;
    };

    const discountApplications = (cart) => Array.isArray(cart.cart_level_discount_applications)
      ? cart.cart_level_discount_applications
      : [];

    const appliedDiscountTitles = (cart) => {
      const titles = discountApplications(cart).map((application) => application.title);
      (cart.items || []).forEach((item) => {
        (item.discount_allocations || []).forEach((allocation) => {
          const title = allocation.discount_application?.title;
          if (title) titles.push(title);
        });
      });
      return titles.filter(Boolean);
    };

    const setDiscountStatus = (message, state = '') => {
      if (!discountStatus) return;
      discountStatus.textContent = message;
      if (state) discountStatus.dataset.state = state;
      else delete discountStatus.dataset.state;
    };

    const renderDiscounts = (cart) => {
      if (!cartDiscounts) return;
      const applications = discountApplications(cart);
      cartDiscounts.replaceChildren();
      cartDiscounts.hidden = applications.length === 0;
      applications.forEach((application) => {
        const row = document.createElement('p');
        const title = document.createElement('span');
        const amount = document.createElement('span');
        title.textContent = application.title;
        amount.textContent = `\u2212${money(application.total_allocated_amount, cart.currency)}`;
        row.append(title, amount);
        cartDiscounts.append(row);
      });
    };

    const renderCartState = (cart) => {
      paintOffers(cart);
      const countLabel = `${cart.item_count} ${cart.item_count === 1 ? 'item' : 'items'}`;
      if (cartTabCount) cartTabCount.textContent = cart.item_count;
      if (cartSummaryCount) cartSummaryCount.textContent = countLabel;
      if (cartSubtotal) cartSubtotal.textContent = money(cart.total_price, cart.currency, true);
      renderDiscounts(cart);

      document.querySelectorAll('.ode-cart-count').forEach((count) => {
        count.textContent = cart.item_count;
      });
      document.querySelectorAll('.ode-cart-link').forEach((link) => {
        link.setAttribute('aria-label', `Cart with ${countLabel}`);
      });

      root.querySelectorAll('[data-ode-cart-item]').forEach((itemElement) => {
        const item = cart.items.find((entry) => entry.key === itemElement.dataset.lineKey);
        if (!item) {
          itemElement.remove();
          return;
        }
        const quantity = itemElement.querySelector('[data-ode-quantity-input]');
        const linePrice = itemElement.querySelector('[data-ode-line-price]');
        if (quantity) quantity.value = item.quantity;
        if (linePrice) linePrice.textContent = money(item.final_line_price, cart.currency);
        const was = itemElement.querySelector('[data-ode-line-was]');
        if (was) {
          const unit = Number(itemElement.querySelector('[data-ode-compare-unit]')?.dataset.odeCompareUnit) || 0;
          const wasCents = Math.max(unit * item.quantity, item.original_line_price);
          was.hidden = wasCents <= item.final_line_price;
          was.textContent = money(wasCents, cart.currency);
        }
      });

      if (cart.item_count === 0) window.location.reload();
    };

    const showCodes = (cart) => {
      const applied = (window.odeOffers?.codes(cart) || []).find((entry) => entry.ok);
      if (discountInput) discountInput.value = applied?.code || '';
      if (applied) setDiscountStatus(`${applied.code} applied. Your total has been updated.`, 'success');
      else setDiscountStatus('Apply a code to preview your savings before checkout.');
    };

    const applyDiscount = async () => {
      if (!discountInput || !discountButton) return;
      const code = discountInput.value.trim().toUpperCase();
      discountInput.value = code;
      if (!code) {
        setDiscountStatus('Enter a discount code to continue.', 'error');
        discountInput.focus();
        return;
      }
      window.odeOffers?.chose(code);

      const originalButtonText = discountButton.textContent;
      discountButton.disabled = true;
      discountInput.disabled = true;
      discountButton.textContent = 'Applying';
      setDiscountStatus('Checking your code…');

      try {
        const routesRoot = window.Shopify?.routes?.root || '/';
        const response = await fetch(`${routesRoot}cart/update.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ discount: code }),
        });
        if (!response.ok) throw new Error('Discount update failed');
        const cart = await response.json();
        renderCartState(cart);

        const isApplied = appliedDiscountTitles(cart)
          .some((title) => title.toUpperCase() === code);
        if (isApplied) {
          setDiscountStatus(`${code} applied. Your total has been updated.`, 'success');
        } else {
          setDiscountStatus('This code is not valid for the items in your cart. Check the spelling or eligibility.', 'error');
        }
      } catch (error) {
        setDiscountStatus('We could not check this code. Please try again.', 'error');
      } finally {
        discountButton.disabled = false;
        discountInput.disabled = false;
        discountButton.textContent = originalButtonText;
      }
    };

    const updateCartItem = async (quantityInput, quantity) => {
      const itemElement = quantityInput.closest('[data-ode-cart-item]');
      const lineKey = itemElement?.dataset.lineKey;
      if (!lineKey) return;
      const previousQuantity = Number.parseInt(quantityInput.value || '0', 10);
      const nextQuantity = Math.max(0, Number.isFinite(quantity) ? quantity : previousQuantity);
      const controls = itemElement.querySelectorAll('button, input');
      controls.forEach((control) => { control.disabled = true; });
      quantityInput.value = nextQuantity;

      try {
        const response = await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: lineKey, quantity: nextQuantity }),
        });
        if (!response.ok) throw new Error('Cart update failed');
        renderCartState(await response.json());
      } catch (error) {
        quantityInput.value = previousQuantity;
      } finally {
        controls.forEach((control) => { control.disabled = false; });
      }
    };

    const productForHandle = async (handle) => {
      if (productCache.has(handle)) return productCache.get(handle);
      const response = await fetch(`/products/${encodeURIComponent(handle)}.js`, {
        headers: { Accept: 'application/json' },
      });
      if (!response.ok) throw new Error('Product options unavailable');
      const product = await response.json();
      productCache.set(handle, product);
      return product;
    };

    const normalizedVariantOptions = (variant) => {
      if (Array.isArray(variant?.options)) return variant.options;
      return [variant?.option1, variant?.option2, variant?.option3].filter((value) => value != null);
    };

    const swatchColor = (value) => {
      const normalized = String(value || '').trim().toLowerCase();
      const colors = {
        black: '#282627',
        blue: '#7195b8',
        brown: '#8d654d',
        gold: '#c79a3b',
        green: '#75866d',
        ivory: '#f3eee5',
        pink: '#e6a6b3',
        purple: '#8b7299',
        red: '#a93645',
        silver: '#c4c7cc',
        white: '#fffaf5',
      };
      const matched = Object.keys(colors).find((name) => normalized.includes(name));
      return matched ? colors[matched] : '#d8c5b2';
    };

    const selectedEditValues = (dialog) => {
      const values = new Map();
      dialog.querySelectorAll('[data-ode-cart-edit-option]').forEach((button) => {
        if (button.getAttribute('aria-pressed') === 'true') {
          values.set(Number(button.dataset.optionPosition), button.dataset.optionValue);
        }
      });
      return values;
    };

    const syncEditDialog = (dialog) => {
      const product = dialog.odeProduct;
      if (!product) return;
      const values = selectedEditValues(dialog);
      const buttons = [...dialog.querySelectorAll('[data-ode-cart-edit-option]')];

      buttons.forEach((button) => {
        const candidateValues = new Map(values);
        candidateValues.set(Number(button.dataset.optionPosition), button.dataset.optionValue);
        const possible = product.variants.some((variant) => {
          if (!variant.available) return false;
          const options = normalizedVariantOptions(variant);
          return [...candidateValues].every(([position, value]) => options[position] === value);
        });
        button.disabled = !possible;
      });

      const selectedVariant = product.variants.find((variant) => {
        const options = normalizedVariantOptions(variant);
        return values.size === product.options.length
          && [...values].every(([position, value]) => options[position] === value);
      });
      dialog.odeSelectedVariant = selectedVariant || null;

      const save = dialog.querySelector('[data-ode-cart-edit-save]');
      const status = dialog.querySelector('[data-ode-cart-edit-status]');
      const currentVariantId = Number(dialog.dataset.currentVariantId);
      if (save) save.disabled = !selectedVariant?.available || selectedVariant.id === currentVariantId;
      if (status && status.dataset.state !== 'error') {
        status.textContent = selectedVariant?.available ? '' : 'This combination is currently unavailable.';
      }

      const image = dialog.querySelector('[data-ode-cart-edit-image]');
      const imageSource = selectedVariant?.featured_image?.src || selectedVariant?.featured_image || '';
      if (image && typeof imageSource === 'string' && imageSource) {
        image.src = imageSource;
        image.removeAttribute('srcset');
      }
    };

    const renderEditDialog = (dialog, product) => {
      dialog.odeProduct = product;
      const optionsHost = dialog.querySelector('[data-ode-cart-edit-options]');
      const currentVariantId = Number(dialog.dataset.currentVariantId);
      const currentVariant = product.variants.find((variant) => variant.id === currentVariantId)
        || product.variants[0];
      const currentValues = normalizedVariantOptions(currentVariant);
      optionsHost.replaceChildren();

      product.options.forEach((rawOptionName, position) => {
        const optionName = typeof rawOptionName === 'string' ? rawOptionName : rawOptionName.name;
        const group = document.createElement('fieldset');
        group.className = 'ode-cart-edit__group';
        const legend = document.createElement('legend');
        legend.textContent = optionName;
        const values = document.createElement('div');
        values.className = 'ode-cart-edit__values';
        const uniqueValues = [...new Set(product.variants.map((variant) => normalizedVariantOptions(variant)[position]))]
          .filter(Boolean);

        uniqueValues.forEach((value) => {
          const button = document.createElement('button');
          button.className = 'ode-cart-edit__option';
          button.type = 'button';
          button.dataset.odeCartEditOption = '';
          button.dataset.optionPosition = position;
          button.dataset.optionValue = value;
          button.setAttribute('aria-pressed', String(currentValues[position] === value));
          if (/colou?r/i.test(optionName)) {
            const swatch = document.createElement('span');
            swatch.className = 'ode-cart-edit__swatch';
            swatch.style.setProperty('--ode-cart-edit-swatch', swatchColor(value));
            swatch.setAttribute('aria-hidden', 'true');
            button.append(swatch);
          }
          button.append(document.createTextNode(value));
          values.append(button);
        });

        group.append(legend, values);
        optionsHost.append(group);
      });

      const status = dialog.querySelector('[data-ode-cart-edit-status]');
      if (status) {
        status.textContent = '';
        delete status.dataset.state;
      }
      syncEditDialog(dialog);
    };

    const openEditDialog = async (trigger) => {
      const dialogId = trigger.getAttribute('aria-controls');
      const dialog = dialogId ? document.getElementById(dialogId) : null;
      if (!dialog) return;
      if (!dialog.open) dialog.showModal();
      const status = dialog.querySelector('[data-ode-cart-edit-status]');

      try {
        const product = await productForHandle(dialog.dataset.productHandle);
        renderEditDialog(dialog, product);
        dialog.querySelector('[aria-pressed="true"]')?.focus();
      } catch (error) {
        if (status) {
          status.textContent = 'We could not load the available options. Close this window and try again.';
          status.dataset.state = 'error';
        }
      }
    };

    const updateEditedVariant = async (dialog) => {
      const selectedVariant = dialog.odeSelectedVariant;
      const save = dialog.querySelector('[data-ode-cart-edit-save]');
      const status = dialog.querySelector('[data-ode-cart-edit-status]');
      if (!selectedVariant?.available || !save) return;
      const originalLabel = save.textContent;
      const controls = dialog.querySelectorAll('button');
      controls.forEach((control) => { control.disabled = true; });
      save.textContent = 'Updating';
      if (status) {
        status.textContent = 'Updating your selection…';
        delete status.dataset.state;
      }

      try {
        const rootPath = window.Shopify?.routes?.root || '/';
        const cartResponse = await fetch(`${rootPath}cart.js`, { headers: { Accept: 'application/json' } });
        if (!cartResponse.ok) throw new Error('Cart unavailable');
        const cart = await cartResponse.json();
        const currentVariantId = Number(dialog.dataset.currentVariantId);
        const oldLine = cart.items.find((item) => item.key === dialog.dataset.lineKey)
          || cart.items.find((item) => item.id === currentVariantId);
        if (!oldLine) throw new Error('Original selection unavailable');

        const targetLine = cart.items.find((item) => item.id === selectedVariant.id && item.key !== oldLine.key);
        const updates = { [oldLine.key]: 0 };
        if (targetLine) updates[targetLine.key] = targetLine.quantity + oldLine.quantity;
        else updates[String(selectedVariant.id)] = oldLine.quantity;

        const updateResponse = await fetch(`${rootPath}cart/update.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ updates }),
        });
        if (!updateResponse.ok) throw new Error('Variant update failed');
        const updatedCart = await updateResponse.json();
        if (!updatedCart.items.some((item) => item.id === selectedVariant.id)) {
          throw new Error('Updated selection missing');
        }
        window.location.reload();
      } catch (error) {
        controls.forEach((control) => { control.disabled = false; });
        syncEditDialog(dialog);
        save.textContent = originalLabel;
        if (status) {
          status.textContent = 'Your original selection is still in the cart. Please try the update again.';
          status.dataset.state = 'error';
        }
      }
    };

    const readItems = () => {
      try {
        const items = JSON.parse(localStorage.getItem(storageKey) || '[]');
        return Array.isArray(items) ? items : [];
      } catch (error) {
        return [];
      }
    };

    const writeItems = (items) => {
      try {
        localStorage.setItem(storageKey, JSON.stringify(items));
      } catch (error) {
        return;
      }
    };

    const safeProductUrl = (value) => {
      try {
        const url = new URL(value, window.location.origin);
        return url.origin === window.location.origin ? url.href : '#';
      } catch (error) {
        return '#';
      }
    };

    const safeImageUrl = (value) => {
      try {
        const url = new URL(value, window.location.origin);
        if (url.protocol !== 'https:') return '';
        if (url.hostname === 'cdn.shopify.com') url.searchParams.set('width', '1400');
        return url.href;
      } catch (error) {
        return '';
      }
    };

    const refreshSavedImage = async (item, imageLink) => {
      try {
        const response = await fetch(`/products/${encodeURIComponent(item.handle)}.js`, {
          headers: { Accept: 'application/json' },
        });
        if (!response.ok) return;
        const product = await response.json();
        const featuredImage = typeof product.featured_image === 'string'
          ? product.featured_image
          : product.featured_image?.src || product.images?.[0];
        const imageUrl = safeImageUrl(featuredImage);
        if (!imageUrl || !imageLink.isConnected) return;
        let image = imageLink.querySelector('img');
        if (!image) {
          image = document.createElement('img');
          image.alt = '';
          image.loading = 'lazy';
          imageLink.replaceChildren(image);
        }
        image.src = imageUrl;
      } catch (error) {
        return;
      }
    };

    const setTab = (name, updateHash = true) => {
      const activeName = name === 'saved' ? 'saved' : 'cart';
      tabs.forEach((tab) => {
        const isActive = tab.dataset.odeCartTab === activeName;
        tab.classList.toggle('is-active', isActive);
        tab.setAttribute('aria-selected', String(isActive));
        tab.tabIndex = isActive ? 0 : -1;
      });
      panels.forEach((panel) => {
        panel.hidden = panel.dataset.odeCartPanel !== activeName;
      });
      if (updateHash) history.replaceState(null, '', activeName === 'saved' ? '#saved' : '#cart');
    };

    const renderSaved = () => {
      if (!savedGrid || !savedCount) return;
      const items = readItems();
      savedCount.textContent = items.length;
      savedGrid.replaceChildren();

      if (items.length === 0) {
        const empty = document.createElement('div');
        empty.className = 'ode-cart__empty';
        const heart = document.createElement('span');
        heart.className = 'ode-cart__empty-heart';
        heart.setAttribute('aria-hidden', 'true');
        heart.textContent = '♡';
        const heading = document.createElement('h2');
        heading.textContent = 'Nothing saved yet';
        const copy = document.createElement('p');
        copy.textContent = 'Tap the heart on any item and it will wait for you here.';
        const link = document.createElement('a');
        link.className = 'ode-cart__primary-link';
        link.href = root.dataset.allProductsUrl;
        link.textContent = 'Find something you love';
        empty.append(heart, heading, copy, link);
        savedGrid.append(empty);
        return;
      }

      items.forEach((item) => {
        const card = document.createElement('article');
        card.className = 'ode-saved-card';
        card.dataset.savedHandle = item.handle;

        const imageLink = document.createElement('a');
        imageLink.className = 'ode-saved-card__image';
        imageLink.href = safeProductUrl(item.url);
        imageLink.setAttribute('aria-label', `View ${item.title}`);
        const imageUrl = safeImageUrl(item.image);
        if (imageUrl) {
          const image = document.createElement('img');
          image.src = imageUrl;
          image.alt = '';
          image.loading = 'lazy';
          imageLink.append(image);
        } else {
          const heart = document.createElement('span');
          heart.setAttribute('aria-hidden', 'true');
          heart.textContent = '♥';
          imageLink.append(heart);
        }

        const copy = document.createElement('div');
        copy.className = 'ode-saved-card__copy';
        const title = document.createElement('a');
        title.className = 'ode-saved-card__title';
        title.href = safeProductUrl(item.url);
        title.textContent = item.title;
        const price = document.createElement('span');
        price.className = 'ode-saved-card__price';
        price.textContent = item.price;
        copy.append(title, price);

        const actions = document.createElement('div');
        actions.className = 'ode-saved-card__actions';
        const move = document.createElement('button');
        move.className = 'ode-saved-card__move';
        move.type = 'button';
        move.dataset.odeMoveToCart = item.handle;
        move.textContent = 'Move to Cart';
        const remove = document.createElement('button');
        remove.className = 'ode-saved-card__remove';
        remove.type = 'button';
        remove.dataset.odeSavedRemove = item.handle;
        remove.setAttribute('aria-label', `Remove ${item.title}`);
        remove.textContent = '×';
        actions.append(move, remove);

        card.append(imageLink, copy, actions);
        savedGrid.append(card);
        refreshSavedImage(item, imageLink);
      });
    };

    tabs.forEach((tab) => {
      tab.addEventListener('click', () => setTab(tab.dataset.odeCartTab));
    });

    discountButton?.addEventListener('click', applyDiscount);
    discountInput?.addEventListener('keydown', (event) => {
      if (event.key !== 'Enter') return;
      event.preventDefault();
      applyDiscount();
    });

    editDialogs.forEach((dialog) => {
      dialog.addEventListener('click', (event) => {
        if (event.target === dialog) dialog.close();
      });
    });

    root.addEventListener('click', async (event) => {
      const editTrigger = event.target.closest('[data-ode-cart-edit]');
      if (editTrigger) {
        await openEditDialog(editTrigger);
        return;
      }

      const editClose = event.target.closest('[data-ode-cart-edit-close]');
      if (editClose) {
        editClose.closest('[data-ode-cart-edit-dialog]')?.close();
        return;
      }

      const editOption = event.target.closest('[data-ode-cart-edit-option]');
      if (editOption) {
        const dialog = editOption.closest('[data-ode-cart-edit-dialog]');
        dialog.querySelectorAll('[data-ode-cart-edit-option]').forEach((button) => {
          if (button.dataset.optionPosition === editOption.dataset.optionPosition) {
            button.setAttribute('aria-pressed', String(button === editOption));
          }
        });
        syncEditDialog(dialog);
        return;
      }

      const editSave = event.target.closest('[data-ode-cart-edit-save]');
      if (editSave) {
        await updateEditedVariant(editSave.closest('[data-ode-cart-edit-dialog]'));
        return;
      }

      const minus = event.target.closest('[data-ode-quantity-minus]');
      const plus = event.target.closest('[data-ode-quantity-plus]');
      if (minus || plus) {
        const quantity = (minus || plus).parentElement.querySelector('[data-ode-quantity-input]');
        const currentValue = Number.parseInt(quantity.value || '0', 10);
        await updateCartItem(quantity, currentValue + (plus ? 1 : -1));
        return;
      }

      const remove = event.target.closest('[data-ode-saved-remove]');
      if (remove) {
        const items = readItems().filter((item) => item.handle !== remove.dataset.odeSavedRemove);
        writeItems(items);
        renderSaved();
        window.renderOdeWishlist?.();
        if (savedStatus) savedStatus.textContent = 'Removed from Saved Items.';
        return;
      }

      const move = event.target.closest('[data-ode-move-to-cart]');
      if (!move) return;

      const handle = move.dataset.odeMoveToCart;
      const item = readItems().find((savedItem) => savedItem.handle === handle);
      if (!item) return;

      move.disabled = true;
      move.textContent = 'Adding';
      if (savedStatus) savedStatus.textContent = '';

      try {
        const productResponse = await fetch(`/products/${encodeURIComponent(handle)}.js`);
        if (!productResponse.ok) throw new Error('Product unavailable');
        const product = await productResponse.json();
        const savedUrl = new URL(item.url, window.location.origin);
        const savedVariantId = Number.parseInt(savedUrl.searchParams.get('variant') || '0', 10);
        const variant = product.variants.find((entry) => entry.id === savedVariantId && entry.available)
          || product.variants.find((entry) => entry.available);
        if (!variant) throw new Error('Variant unavailable');

        const addResponse = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [{ id: variant.id, quantity: 1 }] }),
        });
        if (!addResponse.ok) throw new Error('Could not add item');

        writeItems(readItems().filter((savedItem) => savedItem.handle !== handle));
        window.location.assign(`${root.dataset.cartUrl}#cart`);
      } catch (error) {
        move.disabled = false;
        move.textContent = 'Move to Cart';
        if (savedStatus) savedStatus.textContent = 'Could not add this item. Please try again.';
      }
    });

    root.addEventListener('change', async (event) => {
      const quantity = event.target.closest('[data-ode-quantity-input]');
      if (!quantity) return;
      await updateCartItem(quantity, Number.parseInt(quantity.value || '0', 10));
    });

    root.addEventListener('click', async (event) => {
      const early = event.target.closest('[data-ode-offers-early]');
      const offers = window.odeOffers;
      if (!early || !offers) return;
      const add = early.dataset.odeOffersEarly === 'apply';
      offers.chose(add ? offers.code : '');
      early.disabled = true;
      try {
        const cart = await updateCodes(add ? offers.code : '');
        renderCartState(cart);
        showCodes(cart);
        if (add && !offers.applied(cart)) setDiscountStatus(`${offers.code} can't be used on this cart right now.`, 'error');
      } catch (error) {
        setDiscountStatus('We could not update your codes. Please try again.', 'error');
      } finally {
        early.disabled = false;
      }
    });

    // EARLYCUPID goes on for the shopper while it runs (rules in window.odeOffers.wantsEarly).
    const startOffers = async () => {
      const offers = window.odeOffers;
      if (!offers || !firstCart) return;
      paintOffers(firstCart);
      if (!offers.wantsEarly(root, firstCart)) return;
      try {
        // Liquid's cart json has no token or discount_codes; cart.js has both.
        const fresh = await fetch(`${routesRoot}cart.js`, { headers: { Accept: 'application/json' } }).then((response) => response.json());
        if (!offers.wantsEarly(root, fresh)) return;
        offers.tried(fresh);
        let cart = await updateCodes(offers.code);
        if (!offers.applied(cart)) cart = await updateCodes('');
        renderCartState(cart);
        showCodes(cart);
      } catch (error) {}
    };
    if (window.odeOffers || document.readyState !== 'loading') startOffers();
    else document.addEventListener('DOMContentLoaded', startOffers, { once: true });

    window.addEventListener('storage', renderSaved);
    window.addEventListener('hashchange', () => setTab(window.location.hash === '#saved' ? 'saved' : 'cart', false));
    renderSaved();
    setTab(window.location.hash === '#saved' ? 'saved' : 'cart', false);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection"]) return;
  try {
    
  const initializeOdePriceRanges = (root = document) => {
    root.querySelectorAll('[data-price-range]').forEach((range) => {
      if (range.dataset.initialized === 'true') return;

      const minimumRange = range.querySelector('[data-price-range-min]');
      const maximumRange = range.querySelector('[data-price-range-max]');
      const fields = range.closest('.ode-collection__filter-options')?.querySelectorAll('input[type="number"]');
      const minimumField = fields?.[0];
      const maximumField = fields?.[1];

      if (!minimumRange || !maximumRange || !minimumField || !maximumField) return;

      const maximum = Number(maximumRange.max) || 1;
      const clamp = (value) => Math.min(maximum, Math.max(0, Number(value) || 0));

      const render = () => {
        let minimum = clamp(minimumRange.value);
        let maximumValue = clamp(maximumRange.value);

        if (minimum > maximumValue) minimum = maximumValue;

        minimumRange.value = minimum;
        maximumRange.value = maximumValue;
        range.style.setProperty('--price-min', `${(minimum / maximum) * 100}%`);
        range.style.setProperty('--price-max', `${(maximumValue / maximum) * 100}%`);
      };

      minimumRange.addEventListener('input', () => {
        if (Number(minimumRange.value) > Number(maximumRange.value)) {
          minimumRange.value = maximumRange.value;
        }
        minimumField.value = minimumRange.value;
        render();
      });

      maximumRange.addEventListener('input', () => {
        if (Number(maximumRange.value) < Number(minimumRange.value)) {
          maximumRange.value = minimumRange.value;
        }
        maximumField.value = maximumRange.value;
        render();
      });

      minimumField.addEventListener('input', () => {
        minimumRange.value = minimumField.value || 0;
        render();
      });

      maximumField.addEventListener('input', () => {
        maximumRange.value = maximumField.value || maximum;
        render();
      });

      range.dataset.initialized = 'true';
      render();
    });
  };

  initializeOdePriceRanges();
  document.addEventListener('shopify:section:load', (event) => initializeOdePriceRanges(event.target));

  const initializeOdeFilterToggles = (root = document) => {
    root.querySelectorAll('[data-ode-filter-toggle]').forEach((button) => {
      if (button.dataset.initialized === 'true') return;
      const layout = button.closest('.ode-collection__layout');
      const label = button.querySelector('[data-ode-filter-toggle-label]');
      if (!layout) return;

      button.addEventListener('click', () => {
        const open = layout.classList.toggle('is-filter-open');
        button.setAttribute('aria-expanded', String(open));
        if (label) label.textContent = open ? 'Hide filters' : 'Filters';
      });

      button.dataset.initialized = 'true';
    });
  };

  initializeOdeFilterToggles();
  document.addEventListener('shopify:section:load', (event) => initializeOdeFilterToggles(event.target));

  // A category row that scrolls sideways (phones, or a long row) opens with
  // the current tile centred, so a shopper sees where they are. Only the
  // row scrolls, never the page.
  const revealOdeCurrentCategory = (root = document) => {
    root.querySelectorAll('.ode-collection__categories, .ode-collection__tier-tiles').forEach((row) => {
      const tile = row.querySelector('.ode-collection__category.is-active');
      if (!tile || row.scrollWidth <= row.clientWidth) return;

      const rowBox = row.getBoundingClientRect();
      const tileBox = tile.getBoundingClientRect();
      const offset = tileBox.left - rowBox.left - (row.clientWidth - tileBox.width) / 2;
      row.scrollLeft = Math.max(0, row.scrollLeft + offset);
    });
  };

  revealOdeCurrentCategory();
  document.addEventListener('shopify:section:load', (event) => revealOdeCurrentCategory(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ode-featured-products"] && !Shopify.designMode) return;
  try {
    
  if (!window.odeFeaturedRailReady) {
    window.odeFeaturedRailReady = true;

    const stepFor = (rail) => {
      const card = rail.querySelector('.ode-product-card');
      if (!card) return rail.clientWidth * 0.8;
      const gap = parseFloat(getComputedStyle(rail).columnGap) || 0;
      return card.getBoundingClientRect().width + gap;
    };

    const sync = (rail) => {
      const controls = rail.parentElement.querySelector('[data-featured-controls]');
      if (!controls) return;
      const scrollable = rail.scrollWidth - rail.clientWidth;
      controls.hidden = scrollable <= 4;
      const prev = controls.querySelector('[data-featured-prev]');
      const next = controls.querySelector('[data-featured-next]');
      if (prev) prev.disabled = rail.scrollLeft <= 2;
      if (next) next.disabled = rail.scrollLeft >= scrollable - 2;
      const position = controls.querySelector('[data-featured-position]');
      if (position) {
        const count = rail.children.length;
        position.textContent = `${Math.min(count, Math.round(rail.scrollLeft / stepFor(rail)) + 1)} / ${count}`;
      }
    };

    const bind = () => {
      document.querySelectorAll('[data-featured-rail]').forEach((rail) => {
        if (rail.dataset.railBound) return;
        rail.dataset.railBound = 'true';

        const controls = rail.parentElement.querySelector('[data-featured-controls]');
        if (controls) {
          controls.addEventListener('click', (event) => {
            const direction = event.target.closest('[data-featured-next]')
              ? 1
              : event.target.closest('[data-featured-prev]')
                ? -1
                : 0;
            if (direction) rail.scrollBy({ left: direction * stepFor(rail), behavior: 'smooth' });
          });
        }

        rail.addEventListener('keydown', (event) => {
          if (event.target !== rail || !['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
          event.preventDefault();
          rail.scrollBy({ left: (event.key === 'ArrowRight' ? 1 : -1) * stepFor(rail), behavior: 'smooth' });
        });
        let start = null;
        let moved = false;
        rail.addEventListener('pointerdown', (event) => {
          if (event.pointerType !== 'mouse' || event.button !== 0 || event.target.closest('button')) return;
          start = { x: event.clientX, left: rail.scrollLeft };
          moved = false;
        });
        rail.addEventListener('pointermove', (event) => {
          if (!start) return;
          const distance = event.clientX - start.x;
          if (Math.abs(distance) <= 5) return;
          moved = true;
          rail.classList.add('is-dragging');
          rail.setPointerCapture(event.pointerId);
          rail.scrollLeft = start.left - distance;
        });
        const stop = () => { start = null; rail.classList.remove('is-dragging'); };
        rail.addEventListener('pointerup', stop);
        rail.addEventListener('pointercancel', stop);
        rail.addEventListener('click', (event) => {
          if (!moved) return;
          event.preventDefault();
          event.stopPropagation();
          moved = false;
        }, true);
        rail.addEventListener('dragstart', (event) => event.preventDefault());
        rail.addEventListener('scroll', () => sync(rail), { passive: true });
        if (window.ResizeObserver) new ResizeObserver(() => sync(rail)).observe(rail);
        sync(rail);
      });
    };

    bind();
    document.addEventListener('shopify:section:load', bind);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ode-header"]) return;
  try {
    
  (() => {
    const storageKey = 'cupids-ode-saved-pieces';

    const readItems = () => {
      try {
        const storedItems = JSON.parse(localStorage.getItem(storageKey) || '[]');
        return Array.isArray(storedItems) ? storedItems : [];
      } catch (error) {
        return [];
      }
    };

    const writeItems = (items) => {
      try {
        localStorage.setItem(storageKey, JSON.stringify(items));
      } catch (error) {
        return;
      }
    };

    const safeProductUrl = (value) => {
      try {
        const productUrl = new URL(value, window.location.origin);
        return productUrl.origin === window.location.origin ? productUrl.href : '#';
      } catch (error) {
        return '#';
      }
    };

    const safeImageUrl = (value) => {
      try {
        const imageUrl = new URL(value, window.location.origin);
        if (imageUrl.protocol !== 'https:') return '';
        if (imageUrl.hostname === 'cdn.shopify.com') imageUrl.searchParams.set('width', '900');
        return imageUrl.href;
      } catch (error) {
        return '';
      }
    };

    const renderWishlist = () => {
      const items = readItems();

      // Pieces saved before the cover crop was recorded pick it up, with the
      // cover, from a card for them on the page. Only a missing crop is filled,
      // so two open tabs can never keep overwriting each other.
      let filled = false;
      document.querySelectorAll('[data-ode-wishlist-toggle][data-product-crop]').forEach((button) => {
        const item = items.find((entry) => entry.handle === button.dataset.productHandle);
        if (!item || item.crop) return;
        item.crop = button.dataset.productCrop;
        if (button.dataset.productImage) item.image = button.dataset.productImage;
        filled = true;
      });
      if (filled) writeItems(items);
      const savedHandles = new Set(items.map((item) => item.handle));

      document.querySelectorAll('[data-ode-wishlist-toggle]').forEach((button) => {
        const isSaved = savedHandles.has(button.dataset.productHandle);
        button.classList.toggle('is-active', isSaved);
        button.setAttribute('aria-pressed', String(isSaved));
        button.setAttribute('aria-label', `${isSaved ? 'Remove' : 'Save'} ${button.dataset.productTitle}`);
        const heart = button.querySelector('span');
        if (heart) heart.textContent = isSaved ? '♥' : '♡';
      });

      document.querySelectorAll('[data-ode-wishlist-list]').forEach((list) => {
        list.replaceChildren();

        if (items.length === 0) {
          const empty = document.createElement('p');
          empty.className = 'ode-wishlist-drawer__empty';
          empty.textContent = 'Pieces you love will appear here.';
          list.append(empty);
          return;
        }

        items.forEach((item) => {
          const row = document.createElement('article');
          row.className = 'ode-wishlist-item';

          const imageUrl = safeImageUrl(item.image);
          if (imageUrl) {
            const imageLink = document.createElement('a');
            imageLink.href = safeProductUrl(item.url);
            const image = document.createElement('img');
            image.src = imageUrl;
            image.alt = '';
            image.loading = 'lazy';
            imageLink.append(image);
            row.append(imageLink);
          } else {
            const imagePlaceholder = document.createElement('span');
            row.append(imagePlaceholder);
          }

          const copy = document.createElement('a');
          copy.className = 'ode-wishlist-item__copy';
          copy.href = safeProductUrl(item.url);
          const title = document.createElement('strong');
          title.textContent = item.title;
          const price = document.createElement('span');
          price.textContent = item.price;
          copy.append(title, price);
          row.append(copy);

          const remove = document.createElement('button');
          remove.className = 'ode-wishlist-item__remove';
          remove.type = 'button';
          remove.dataset.odeWishlistRemove = item.handle;
          remove.setAttribute('aria-label', `Remove ${item.title}`);
          remove.textContent = '×';
          row.append(remove);

          list.append(row);
        });
      });
    };

    const closeDrawers = () => {
      document.querySelectorAll('[data-ode-wishlist-drawer]').forEach((drawer) => {
        drawer.hidden = true;
      });
      document.querySelectorAll('[data-ode-wishlist-open]').forEach((button) => {
        button.setAttribute('aria-expanded', 'false');
      });
    };

    if (!window.odeWishlistEventsBound) {
      document.addEventListener('click', (event) => {
        const previewToggle = event.target.closest('[data-ode-wishlist-preview]');
        if (previewToggle) {
          const isSaved = previewToggle.getAttribute('aria-pressed') !== 'true';
          previewToggle.classList.toggle('is-active', isSaved);
          previewToggle.setAttribute('aria-pressed', String(isSaved));
          previewToggle.setAttribute('aria-label', isSaved ? 'Preview saved' : 'Preview saved state');
          const previewHeart = previewToggle.querySelector('span');
          if (previewHeart) previewHeart.textContent = isSaved ? '♥' : '♡';
          return;
        }

        const toggle = event.target.closest('[data-ode-wishlist-toggle]');
        if (toggle && !toggle.disabled) {
          const items = readItems();
          const itemIndex = items.findIndex((item) => item.handle === toggle.dataset.productHandle);

          if (itemIndex >= 0) {
            items.splice(itemIndex, 1);
          } else {
            items.push({
              handle: toggle.dataset.productHandle,
              url: toggle.dataset.productUrl,
              title: toggle.dataset.productTitle,
              price: toggle.dataset.productPrice,
              image: toggle.dataset.productImage || '',
              crop: toggle.dataset.productCrop || '',
            });
          }

          writeItems(items);
          renderWishlist();
          return;
        }

        const opener = event.target.closest('[data-ode-wishlist-open]');
        if (opener) {
          const drawer = document.getElementById(opener.getAttribute('aria-controls'));
          const willOpen = drawer?.hidden ?? false;
          closeDrawers();
          if (drawer && willOpen) {
            drawer.hidden = false;
            opener.setAttribute('aria-expanded', 'true');
          }
          return;
        }

        if (event.target.closest('[data-ode-wishlist-close]')) {
          closeDrawers();
          return;
        }

        const remove = event.target.closest('[data-ode-wishlist-remove]');
        if (remove) {
          const items = readItems().filter((item) => item.handle !== remove.dataset.odeWishlistRemove);
          writeItems(items);
          renderWishlist();
        }
      });

      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') closeDrawers();
      });

      window.addEventListener('storage', renderWishlist);
      document.addEventListener('shopify:section:load', renderWishlist);
      window.odeWishlistEventsBound = true;
    }

    window.renderOdeWishlist = renderWishlist;
    renderWishlist();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ode-series"] && !Shopify.designMode) return;
  try {
    
  if (!window.odeSeriesRailReady) {
    window.odeSeriesRailReady = true;

    const bindSeriesRails = () => {
      document.querySelectorAll('[data-series-rail]').forEach((rail) => {
        if (rail.dataset.railBound) return;
        rail.dataset.railBound = 'true';

        const step = () => {
          const card = rail.firstElementChild;
          if (!card) return rail.clientWidth * 0.8;
          return card.getBoundingClientRect().width + (parseFloat(getComputedStyle(rail).columnGap) || 0);
        };
        rail.addEventListener('keydown', (event) => {
          if (event.target !== rail || !['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
          event.preventDefault();
          rail.scrollBy({ left: (event.key === 'ArrowRight' ? 1 : -1) * step(), behavior: 'smooth' });
        });
        let start = null;
        let moved = false;
        rail.addEventListener('pointerdown', (event) => {
          if (event.pointerType !== 'mouse' || event.button !== 0) return;
          start = { x: event.clientX, left: rail.scrollLeft };
          moved = false;
        });
        rail.addEventListener('pointermove', (event) => {
          if (!start) return;
          const distance = event.clientX - start.x;
          if (Math.abs(distance) <= 5) return;
          moved = true;
          rail.classList.add('is-dragging');
          rail.setPointerCapture(event.pointerId);
          rail.scrollLeft = start.left - distance;
        });
        const stop = () => { start = null; rail.classList.remove('is-dragging'); };
        rail.addEventListener('pointerup', stop);
        rail.addEventListener('pointercancel', stop);
        rail.addEventListener('click', (event) => {
          if (!moved) return;
          event.preventDefault();
          event.stopPropagation();
          moved = false;
        }, true);
        rail.addEventListener('dragstart', (event) => event.preventDefault());
      });
    };

    bindSeriesRails();
    document.addEventListener('shopify:section:load', bindSeriesRails);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  (() => {
    const roots = document.querySelectorAll('[data-ode-product-root]');

    roots.forEach((root) => {
      if (root.dataset.odeProductReady === 'true') return;
      root.dataset.odeProductReady = 'true';

      const slides = root.querySelector('[data-ode-product-slides]');
      const slideItems = slides ? [...slides.querySelectorAll('[data-ode-product-slide]')] : [];
      const thumbs = root.querySelectorAll('[data-ode-product-thumb]');
      const previousImage = root.querySelector('[data-ode-product-previous]');
      const nextImage = root.querySelector('[data-ode-product-next]');
      let activeSlide = 0;
      let targetSlide = null;

      // Scroll only the thumb row; scrollIntoView could also jump the page.
      const revealThumb = (thumb) => {
        const row = thumb.parentElement;
        if (!row || row.scrollWidth <= row.clientWidth) return;
        const offset = thumb.getBoundingClientRect().left - row.getBoundingClientRect().left;
        row.scrollTo({ left: row.scrollLeft + offset - (row.clientWidth - thumb.offsetWidth) / 2, behavior: 'smooth' });
      };

      const progressBar = root.querySelector('[data-ode-product-progress]');

      const markSlide = (index) => {
        activeSlide = index;
        progressBar?.style.setProperty('--ode-slide-index', index);
        const src = slideItems[index]?.dataset.imageSrc;
        thumbs.forEach((item) => {
          const isCurrent = item.dataset.imageSrc === src;
          item.classList.toggle('is-active', isCurrent);
          item.setAttribute('aria-pressed', String(isCurrent));
          if (isCurrent) revealThumb(item);
        });
      };

      const goToSlide = (index, behavior = 'smooth') => {
        if (!slides || !slideItems.length) return;
        const nextIndex = (index + slideItems.length) % slideItems.length;
        const left = nextIndex * slides.clientWidth;
        targetSlide = Math.abs(slides.scrollLeft - left) > 1 ? nextIndex : null;
        slides.scrollTo({ left, behavior });
        markSlide(nextIndex);
      };

      const setPrimaryImage = (src) => {
        const index = slideItems.findIndex((slide) => slide.dataset.imageSrc === src);
        if (index >= 0) goToSlide(index);
      };

      let slideFrame = 0;
      slides?.addEventListener('scroll', () => {
        cancelAnimationFrame(slideFrame);
        slideFrame = requestAnimationFrame(() => {
          const index = Math.round(slides.scrollLeft / slides.clientWidth);
          // While an arrow or thumb scroll is under way, wait for it to land.
          if (targetSlide !== null) {
            if (index === targetSlide) targetSlide = null;
            return;
          }
          if (index !== activeSlide && slideItems[index]) markSlide(index);
        });
      }, { passive: true });
      ['pointerdown', 'wheel'].forEach((type) => {
        slides?.addEventListener(type, () => { targetSlide = null; }, { passive: true });
      });

      // Keep the current image in place when the phone rotates. iOS also fires
      // resize when the address bar hides, so only react to width changes.
      let slidesWidth = slides?.clientWidth || 0;
      window.addEventListener('resize', () => {
        if (!slides || slides.clientWidth === slidesWidth) return;
        slidesWidth = slides.clientWidth;
        slides.scrollTo({ left: activeSlide * slidesWidth, behavior: 'instant' });
      });

      thumbs.forEach((thumb) => {
        thumb.addEventListener('click', () => setPrimaryImage(thumb.dataset.imageSrc));
      });

      previousImage?.addEventListener('click', () => goToSlide(activeSlide - 1));
      nextImage?.addEventListener('click', () => goToSlide(activeSlide + 1));

      const variantSelect = root.querySelector('[data-ode-product-variant]');
      const optionButtons = root.querySelectorAll('[data-ode-product-option]');
      const price = root.querySelector('[data-ode-product-price]');
      const submit = root.querySelector('[data-ode-product-submit]');
      const form = root.querySelector('[data-ode-product-form]');
      const status = root.querySelector('[data-ode-product-status]');
      const quantityInput = root.querySelector('[data-ode-quantity-input]');
      const decreaseQuantity = root.querySelector('[data-ode-quantity-decrease]');
      const increaseQuantity = root.querySelector('[data-ode-quantity-increase]');
      const save = root.querySelector('[data-ode-wishlist-toggle]');
      const saveLabel = save?.querySelector('b');
      const updateSaveLabel = () => {
        if (!save || !saveLabel) return;
        saveLabel.textContent = save.getAttribute('aria-pressed') === 'true' ? 'Saved item' : 'Save this piece';
      };

      if (save) {
        new MutationObserver(updateSaveLabel).observe(save, { attributes: true, attributeFilter: ['aria-pressed'] });
        updateSaveLabel();
      }

      const restock = root.querySelector('[data-ode-restock]');

      // Message us opens the Shopify Inbox chat when it has loaded, and falls back
      // to the contact page when it has not.
      root.querySelector('[data-ode-open-chat]')?.addEventListener('click', (event) => {
        const chat = document.querySelector('shopify-chat')?.shadowRoot;
        const opener = chat?.querySelector('.activator-nudge button, .activator button, button.activator');
        if (!opener) return;
        event.preventDefault();
        opener.click();
      });

      const getVariantValues = (option) => [
        option?.dataset.optionOne || '',
        option?.dataset.optionTwo || '',
        option?.dataset.optionThree || '',
      ];

      const optionPositions = [...new Set([...optionButtons].map((button) => Number(button.dataset.optionPosition) - 1))];

      const syncCurrentLabels = () => {
        root.querySelectorAll('[data-ode-option-current]').forEach((label) => {
          const pressed = label.closest('fieldset')?.querySelector('[data-ode-product-option][aria-pressed="true"]');
          label.textContent = pressed?.dataset.optionValue || '';
        });
      };

      const syncOptionButtons = (variantOption) => {
        const values = getVariantValues(variantOption);
        optionButtons.forEach((button) => {
          const position = Number(button.dataset.optionPosition) - 1;
          button.setAttribute('aria-pressed', String(values[position] === button.dataset.optionValue));
        });
        syncCurrentLabels();
      };

      const updateVariant = () => {
        const option = variantSelect?.selectedOptions[0];
        if (!option || !price || !submit) return;

        syncOptionButtons(option);

        price.replaceChildren();
        if (option.dataset.comparePrice) {
          const compare = document.createElement('s');
          compare.textContent = option.dataset.comparePrice;
          price.append(compare);
        }
        const current = document.createElement('span');
        current.textContent = option.dataset.price;
        price.append(current);

        const available = option.dataset.available === 'true';
        submit.disabled = !available;
        submit.textContent = available ? 'Add to bag' : 'Sold out';
        if (restock) restock.hidden = available;

        if (option.dataset.imageSrc) setPrimaryImage(option.dataset.imageSrc);

        const nextUrl = `${root.dataset.productUrl}?variant=${option.value}`;
        window.history.replaceState({}, '', nextUrl);
        if (save) {
          save.dataset.productUrl = nextUrl;
          save.dataset.productPrice = option.dataset.price;
        }
      };

      optionButtons.forEach((button) => {
        button.addEventListener('click', () => {
          if (!variantSelect) return;

          optionButtons.forEach((item) => {
            if (item.dataset.optionPosition === button.dataset.optionPosition) {
              item.setAttribute('aria-pressed', String(item === button));
            }
          });
          syncCurrentLabels();

          const selectedValues = new Map();
          optionButtons.forEach((item) => {
            if (item.getAttribute('aria-pressed') === 'true') {
              selectedValues.set(Number(item.dataset.optionPosition) - 1, item.dataset.optionValue);
            }
          });

          if (!optionPositions.every((position) => selectedValues.has(position))) {
            variantSelect.value = '';
            submit.disabled = true;
            submit.textContent = 'Choose options';
            if (status) status.textContent = '';
            return;
          }

          const variants = [...variantSelect.options];
          const matchingVariant = variants.find((option) => {
            const values = getVariantValues(option);
            return optionPositions.every((position) => values[position] === selectedValues.get(position));
          });

          if (!matchingVariant) {
            variantSelect.value = '';
            submit.disabled = true;
            submit.textContent = 'Currently unavailable';
            if (restock) restock.hidden = true;
            return;
          }
          variantSelect.value = matchingVariant.value;
          updateVariant();
        });
      });

      variantSelect?.addEventListener('change', updateVariant);
      if (variantSelect?.selectedOptions[0]) {
        syncOptionButtons(variantSelect.selectedOptions[0]);
      }

      const sticky = root.querySelector('[data-ode-product-sticky]');
      const stickyPrice = root.querySelector('[data-ode-sticky-price]');
      const stickyAdd = root.querySelector('[data-ode-sticky-add]');

      if (sticky && submit && price) {
        const syncSticky = () => {
          stickyPrice?.replaceChildren(...[...price.childNodes].map((node) => node.cloneNode(true)));
          if (stickyAdd) {
            stickyAdd.textContent = submit.textContent;
            stickyAdd.disabled = submit.disabled;
          }
        };

        // Shopify Inbox pins its chat bubble bottom-right, exactly where the bar's
        // button sits on a phone. Lift it once and leave it there: matching the bar's
        // own show/hide made it jump around as you scrolled. If Inbox renames these
        // classes the bubble simply overlaps again rather than breaking anything.
        const offsetChatBubble = (shift) => {
          const shadow = document.querySelector('shopify-chat')?.shadowRoot;
          if (!shadow) return;
          let style = shadow.querySelector('[data-ode-chat-offset]');
          if (!style) {
            style = document.createElement('style');
            style.setAttribute('data-ode-chat-offset', '');
            shadow.append(style);
          }
          // Same breakpoint as the bar, so a window widened past it puts the
          // bubble back. !important because Inbox styles itself with adopted
          // stylesheets, which come later in the cascade than this tag. :host
          // outranks the site-wide phone lift in layout/theme.liquid, so the
          // bar's height decides here whichever style tag lands last.
          style.textContent = shift
            ? `@media (max-width: 899px) { :host .activator-nudge, :host .activator:not(.activator-nudge .activator) { transform: translateY(-${shift}px) !important; transition: transform 220ms ease; } }`
            : '';
        };

        // Inbox attaches its shadow root a beat after the element lands, so poll for
        // it rather than racing a single DOM callback. Gives up quietly after ~10s.
        // The bar shows on any window under 900px, mouse or touch, so the lift
        // follows the width rather than the pointer; it used to check for touch
        // and left the bubble over Add to bag in a narrow desktop window.
        const narrowWindow = window.matchMedia('(max-width: 899px)');
        // The bar is display: none on wide windows and measures 0 there; 66px is
        // its height on a phone without a home indicator.
        const stickyLift = () => Math.max(sticky.offsetHeight, 66) + 8;
        const liftChatBubble = () => {
          let attempts = 0;
          const attempt = () => {
            if (document.querySelector('shopify-chat')?.shadowRoot) {
              offsetChatBubble(stickyLift());
            } else if (++attempts < 40) {
              window.setTimeout(attempt, 250);
            }
          };
          attempt();
          narrowWindow.addEventListener('change', () => {
            if (narrowWindow.matches) offsetChatBubble(stickyLift());
          });
        };

        const setStickyVisible = (visible) => {
          sticky.classList.toggle('is-visible', visible);
          sticky.setAttribute('aria-hidden', String(!visible));
          if (stickyAdd) stickyAdd.tabIndex = visible ? 0 : -1;
        };

        syncSticky();
        new MutationObserver(syncSticky).observe(price, { childList: true, subtree: true, characterData: true });
        new MutationObserver(syncSticky).observe(submit, {
          childList: true,
          subtree: true,
          characterData: true,
          attributes: true,
          attributeFilter: ['disabled'],
        });

        stickyAdd?.addEventListener('click', () => submit.click());

        new IntersectionObserver((entries) => entries.forEach((entry) => setStickyVisible(!entry.isIntersecting)), {
          rootMargin: '0px 0px -76px 0px',
        }).observe(submit);

        liftChatBubble();
      }

      const setQuantity = (nextQuantity) => {
        if (!quantityInput) return;
        const normalizedQuantity = Math.max(1, Math.floor(Number(nextQuantity) || 1));
        quantityInput.value = String(normalizedQuantity);
      };

      decreaseQuantity?.addEventListener('click', () => setQuantity(Number(quantityInput?.value) - 1));
      increaseQuantity?.addEventListener('click', () => setQuantity(Number(quantityInput?.value) + 1));
      quantityInput?.addEventListener('change', () => setQuantity(quantityInput.value));

      form?.addEventListener('submit', async (event) => {
        event.preventDefault();
        if (!submit || submit.disabled) return;

        const originalLabel = submit.textContent;
        submit.disabled = true;
        submit.textContent = 'Adding to bag';
        if (status) status.textContent = '';

        try {
          const rootPath = window.Shopify?.routes?.root || '/';
          const formData = new FormData(form);
          const productVariantId = Number.parseInt(formData.get('id'), 10);
          const productQuantity = Math.max(1, Number.parseInt(formData.get('quantity') || '1', 10));
          if (!Number.isFinite(productVariantId)) throw new Error('Choose a product option');

          const items = [{ id: productVariantId, quantity: productQuantity }];

          const response = await fetch(`${rootPath}cart/add.js`, {
            method: 'POST',
            headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
            body: JSON.stringify({ items }),
          });

          if (!response.ok) throw new Error('Cart request failed');

          const cartResponse = await fetch(`${rootPath}cart.js`, { headers: { Accept: 'application/json' } });
          if (!cartResponse.ok) throw new Error('Cart refresh failed');
          const cart = await cartResponse.json();

          document.querySelectorAll('.ode-cart-count').forEach((count) => {
            count.textContent = cart.item_count;
          });
          document.querySelectorAll('.ode-cart-link').forEach((link) => {
            link.setAttribute('aria-label', `Cart with ${cart.item_count} items`);
          });

          submit.textContent = 'Added to bag';
          if (status) status.textContent = 'Your piece is in the bag.';
          document.dispatchEvent(new CustomEvent('ode:cart:updated', { detail: cart }));

          window.setTimeout(() => {
            const selected = variantSelect?.selectedOptions[0];
            const available = selected ? selected.dataset.available === 'true' : true;
            submit.disabled = !available;
            submit.textContent = available ? 'Add to bag' : 'Sold out';
          }, 1800);
        } catch (error) {
          submit.disabled = false;
          submit.textContent = originalLabel;
          if (status) status.textContent = 'Something went wrong. Please try again.';
        }
      });

      root.querySelectorAll('.ode-product__accordions details').forEach((detail) => {
        detail.addEventListener('toggle', () => {
          if (!detail.open) return;
          root.querySelectorAll('.ode-product__accordions details').forEach((item) => {
            if (item !== detail) item.open = false;
          });
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["search"]) return;
  try {
    
  (() => {
    const STOP_WORDS = new Set(['the', 'a', 'an', 'and', 'of', 'for', 'with', 'in', 'on', 'to', 'by', 'my']);
    // [field, weight, loose]. Loose fields also match inside words and near
    // misses; the description only counts whole words or word starts, or
    // "val" would find every piece that is "available".
    const FIELDS = [
      ['title', 3, true],
      ['meta', 2, true],
      ['tags', 1.5, true],
      ['body', 0.6, false],
    ];

    const normalize = (value) =>
      (value || '')
        .normalize('NFD')
        .replace(/[̀-ͯ]/g, '')
        .toLowerCase()
        .replace(/[’'`]/g, '')
        .replace(/&/g, ' and ')
        .replace(/[^a-z0-9]+/g, ' ')
        .trim();

    const stem = (word) => {
      if (word.length > 4 && word.endsWith('ies')) return `${word.slice(0, -3)}y`;
      if (word.length > 4 && word.endsWith('sses')) return word.slice(0, -2);
      if (word.length > 3 && word.endsWith('s') && !word.endsWith('ss')) return word.slice(0, -1);
      return word;
    };

    const words = (value) => normalize(value).split(' ').filter(Boolean).map(stem);

    // Edit distance with an early exit once it passes the limit.
    const distance = (a, b, limit) => {
      if (Math.abs(a.length - b.length) > limit) return limit + 1;
      let previous = Array.from({ length: b.length + 1 }, (_, index) => index);
      for (let i = 1; i <= a.length; i += 1) {
        const current = [i];
        let rowMin = i;
        for (let j = 1; j <= b.length; j += 1) {
          const cost = a[i - 1] === b[j - 1] ? 0 : 1;
          current[j] = Math.min(previous[j] + 1, current[j - 1] + 1, previous[j - 1] + cost);
          rowMin = Math.min(rowMin, current[j]);
        }
        if (rowMin > limit) return limit + 1;
        previous = current;
      }
      return previous[b.length];
    };

    // Level 1 takes whole words and word starts, level 2 adds matches inside a
    // word ("alentine"), level 3 adds near misses ("rosete"). The search stops
    // at the first level that finds something, so "lace" never brings up
    // "Palace" and "tights" never brings up "Light".
    const matchWord = (token, word, loose, level) => {
      if (word === token) return 1;
      if (!loose) return token.length >= 4 && word.startsWith(token) ? 0.8 : 0;
      if (token.length >= 2 && word.startsWith(token)) return 0.9;
      if (level >= 2 && token.length >= 3 && word.includes(token)) return 0.6;
      if (level >= 3 && token.length >= 4) {
        const limit = token.length >= 7 ? 2 : 1;
        if (distance(token, word, limit) <= limit) return 0.45;
        if (word.length > token.length && distance(token, word.slice(0, token.length), 1) <= 1) return 0.4;
      }
      return 0;
    };

    const parseSynonyms = (value) => {
      const map = new Map();
      (value || '').split(/\n/).forEach((line) => {
        const [key, list] = line.split(':');
        if (!key || !list) return;
        const keyWord = words(key).join(' ');
        const alternatives = list.split(',').map((entry) => words(entry)).filter((entry) => entry.length);
        if (keyWord) map.set(keyWord, alternatives);
      });
      return map;
    };

    const init = (root) => {
      if (!root || root.dataset.odeSearchBound) return;
      const templates = [...root.querySelectorAll('[data-ode-search-item]')];
      const form = root.querySelector('[data-ode-search-form]');
      const input = form?.querySelector('input[name="q"]');
      const results = root.querySelector('[data-ode-search-results]');
      const picks = root.querySelector('[data-ode-search-picks]');
      if (!templates.length || !form || !input || !results) return;
      root.dataset.odeSearchBound = 'true';

      const synonyms = parseSynonyms(root.dataset.synonyms);
      const items = templates.map((template, order) => {
        const fields = {};
        FIELDS.forEach(([name]) => {
          fields[name] = words(template.dataset[name]);
        });
        return {
          template,
          order,
          fields,
          title: normalize(template.dataset.title),
          phraseText: ` ${normalize(template.dataset.title)} | ${normalize(template.dataset.meta)} | ${normalize(template.dataset.tags)} `,
          available: template.dataset.available === 'true',
        };
      });

      const scoreToken = (item, token, level) => {
        let best = 0;
        FIELDS.forEach(([name, weight, loose]) => {
          const list = item.fields[name];
          for (let index = 0; index < list.length; index += 1) {
            const match = matchWord(token, list[index], loose, level);
            if (match * weight > best) best = match * weight;
            if (match === 1) break;
          }
        });
        return best;
      };

      const scoreGroup = (item, group, level) => {
        // A synonym can be several words ("waist chain"); every word must land.
        let total = 0;
        for (const token of group) {
          const score = scoreToken(item, token, level);
          if (!score) return 0;
          total += score;
        }
        return total / group.length;
      };

      const searchAt = (tokens, phrase, level) => {
        const scored = items.map((item) => {
          let total = 0;
          let matched = 0;
          tokens.forEach((token) => {
            let best = scoreToken(item, token, level);
            (synonyms.get(token) || []).forEach((group) => {
              best = Math.max(best, scoreGroup(item, group, level) * 0.85);
            });
            if (best > 0) matched += 1;
            total += best;
          });
          if (phrase.length > 2 && item.title.includes(phrase)) total += 3;
          return { item, total, matched };
        });
        const byScore = (a, b) =>
          b.total - a.total || Number(b.item.available) - Number(a.item.available) || a.item.order - b.item.order;
        // Several words that appear together in a title, collection or tag
        // ("over the heart", "waist chain", "cherry val") mean that phrase, so
        // only pieces carrying it are shown.
        if (tokens.length > 1) {
          const phraseHits = scored.filter((entry) => entry.item.phraseText.includes(` ${phrase}`)).sort(byScore);
          if (phraseHits.length) return { list: phraseHits.map((entry) => entry.item), exact: true };
        }
        const exact = scored.filter((entry) => entry.matched === tokens.length).sort(byScore);
        if (exact.length) return { list: exact.map((entry) => entry.item), exact: true };
        const partial = scored.filter((entry) => entry.matched > 0).sort(byScore);
        return { list: partial.slice(0, 12).map((entry) => entry.item), exact: false };
      };

      const search = (query) => {
        const tokens = words(query).filter((token) => !STOP_WORDS.has(token));
        if (!tokens.length) return { list: [], exact: true };
        const phrase = normalize(query);
        let closest = { list: [], exact: false };
        for (let level = 1; level <= 3; level += 1) {
          const result = searchAt(tokens, phrase, level);
          if (result.exact && result.list.length) return result;
          if (!closest.list.length) closest = result;
        }
        return closest;
      };

      const element = (tag, className, text) => {
        const node = document.createElement(tag);
        if (className) node.className = className;
        if (text !== undefined) node.textContent = text;
        return node;
      };

      const brand = document.title.includes(' – ') ? document.title.split(' – ').pop() : '';
      const setTitle = (query, count) => {
        const suffix = brand ? ` – ${brand}` : '';
        document.title = query
          ? `Search: ${count} ${count === 1 ? 'result' : 'results'} found for ${query}${suffix}`
          : `Search${suffix}`;
      };

      const setUrl = (query) => {
        const url = new URL(window.location.href);
        url.search = '';
        if (query) {
          url.searchParams.set('q', query);
          url.searchParams.set('type', 'product');
        }
        window.history.replaceState(null, '', url);
      };

      const render = (rawQuery) => {
        const query = rawQuery.trim();
        if (normalize(query).length < 2) {
          root.classList.remove('ode-search-page--results');
          results.hidden = true;
          results.replaceChildren();
          if (picks) picks.hidden = false;
          if (!query) {
            setUrl('');
            setTitle('', 0);
          }
          return;
        }

        const { list, exact } = search(query);
        const heading = element('div', 'ode-search-page__results-heading');
        const headingText = element('div');
        headingText.append(
          element('p', '', exact || !list.length ? 'Search results' : 'Closest matches'),
          element('h2', '', `“${query}”`)
        );
        heading.append(headingText, element('span', '', `${list.length} ${list.length === 1 ? 'piece' : 'pieces'}`));

        const nodes = [heading];
        if (list.length) {
          const grid = element('div', 'ode-search-page__grid');
          list.forEach((item) => grid.append(item.template.content.cloneNode(true)));
          nodes.push(grid);
        } else {
          const empty = element('div', 'ode-search-page__empty');
          empty.append(
            element('h2', '', 'Nothing found yet'),
            element('p', '', 'Try another word, or explore one of the collections below.')
          );
          nodes.push(empty);
        }

        results.replaceChildren(...nodes);
        results.hidden = false;
        root.classList.add('ode-search-page--results');
        if (picks) picks.hidden = list.length > 0;
        setUrl(query);
        setTitle(query, list.length);
        if (typeof window.renderOdeWishlist === 'function') window.renderOdeWishlist();
      };

      let timer;
      input.addEventListener('input', () => {
        window.clearTimeout(timer);
        timer = window.setTimeout(() => render(input.value), 160);
      });

      form.addEventListener('submit', (event) => {
        event.preventDefault();
        window.clearTimeout(timer);
        render(input.value);
        input.blur();
      });

      root.addEventListener('click', (event) => {
        const term = event.target.closest('[data-ode-search-term]');
        if (!term) return;
        event.preventDefault();
        input.value = term.dataset.odeSearchTerm;
        render(input.value);
        results.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });

      const initial = new URLSearchParams(window.location.search).get('q');
      if (initial) {
        input.value = initial;
        render(initial);
      }
    };

    init(document.querySelector('[data-ode-search]'));
    document.addEventListener('shopify:section:load', (event) => {
      init(event.target.querySelector('[data-ode-search]'));
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
